import Header from "../components/common/Header";
import ContactForm from "../components/common/Contact";
import Footer from "../components/common/Footer";
import Career from "../components/biography/Career";
import Private from "../components/biography/Private";
import { Helmet } from "react-helmet";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

const SectionTitle = ({ children }: { children: React.ReactNode }) => (
  <Box sx={{ textAlign: "center", mb: 6 }}>
    <Typography
      variant="h4"
      component="h2"
      sx={{
        fontWeight: 700,
        color: "#0F172A",
        display: "inline-block",
        position: "relative",
        pb: 1.5,
        "&::after": {
          content: '""',
          position: "absolute",
          bottom: 0,
          left: "50%",
          transform: "translateX(-50%)",
          width: 36,
          height: 3,
          backgroundColor: "#3B82F6",
          borderRadius: 2,
        },
      }}
    >
      {children}
    </Typography>
  </Box>
);

function App() {
  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: "#F1F5F9" }}>
      <Helmet
        title="経歴"
        link={[
          { rel: "canonical", href: "https://matsuki-takeshi.com/biography" },
        ]}
        meta={[
          {
            name: "description",
            content:
              "Matsuki Takeshi 松木健 - バックエンドエンジニア |メインはPHP、Laravel、Pythonでのバックエンド開発。Vue.js、React.js、Next.js等を利用したフロントエンド開発。Terraform, AWS等を利用したインフラ構築。",
          },
          {
            property: "og:description",
            content:
              "Matsuki Takeshi 松木健 - バックエンドエンジニア |メインはPHP、Laravel、Pythonでのバックエンド開発。Vue.js、React.js、Next.js等を利用したフロントエンド開発。Terraform, AWS等を利用したインフラ構築。",
          },
          { property: "og:title", content: "経歴" },
          { property: "og:type", content: "経歴紹介" },
          {
            property: "og:url",
            content: "https://matsuki-takeshi.com/biography",
          },
          {
            property: "keywords",
            content: "エンジニア, バックエンド, フリーランス",
          },
        ]}
      />
      <Header />

      {/* Page hero */}
      <Box
        sx={{
          backgroundColor: "#1E293B",
          py: { xs: 5, md: 7 },
          textAlign: "center",
        }}
      >
        <Container maxWidth="lg">
          <Typography
            variant="h3"
            component="h1"
            sx={{
              fontWeight: 700,
              color: "#FFFFFF",
              mb: 1,
              fontSize: { xs: "1.75rem", md: "2.25rem" },
            }}
          >
            My Biography
          </Typography>
          <Typography sx={{ color: "rgba(255,255,255,0.55)", fontSize: "0.95rem" }}>
            経歴・プロフィール紹介
          </Typography>
        </Container>
      </Box>

      {/* Private Section */}
      <Box component="section" sx={{ backgroundColor: "#FFFFFF", py: { xs: 6, md: 8 } }}>
        <Container maxWidth="lg">
          <SectionTitle>Private</SectionTitle>
          <Private />
        </Container>
      </Box>

      {/* Career Section */}
      <Box component="section" sx={{ backgroundColor: "#F8FAFC", py: { xs: 6, md: 8 } }}>
        <Container maxWidth="lg">
          <SectionTitle>Career & Projects</SectionTitle>
          <Career />
        </Container>
      </Box>

      {/* Contact Section */}
      <Box component="section" sx={{ backgroundColor: "#FFFFFF", py: { xs: 6, md: 8 } }}>
        <Container maxWidth="lg">
          <SectionTitle>Contact</SectionTitle>
          <ContactForm />
        </Container>
      </Box>

      <Footer />
    </Box>
  );
}

export default App;
